import types, { methods, versions, stateKey } from './endpointType';
import generateApi from './generate';
import api from './endpoints';

export { methods, api, versions, generateApi, stateKey };

export default types;
